import {useEffect, useMemo, useRef, useState} from 'react'
// import {isEqual} from 'lodash'

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import ClearIcon from '@mui/icons-material/Clear';

import {getStoreFileName} from 'ultra/helpers/storage';
import {isFile} from 'ultra/helpers/utils';

import {useToasterStore} from '../../../Stores/toster';
import {useBackdropPreloaderStore} from '../../../Stores/backdropPreloader';
import {useFormStore} from '../../../Stores/form';

import ContentImage from '../../../Modules/Content/Widgets/ContentImage';

import './index.scss';

export default function UploadImage(props) {
    const {content, disabled, field, isEditMode, onChange, onFocus, onBlur, minimal, hideErrors, hidePreview} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const inputRef = useRef(null);
    const hiddenImagesRef = useRef(null);

    const {hideBackdropPreloader} = useBackdropPreloaderStore();
    const {toaster, showPromt, closeToaster} = useToasterStore();

    const [name, setName] = useState('')
    const [img, setImg] = useState(null)
    const [imgAvailable, setImgAvailable] = useState(false)
    const [showSizeDetails, setShowSizeDetails] = useState(false)

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const onRemoveHandler = () => {
        inputRef.current.value = null;
        onChange({target: {files: [new File([''], 'null-file')]}})
    }

    const onButtonClick = (e) => {
        inputRef.current.click()
    }

    const [placeholder] = useState(field.placeholder ? field.placeholder + (field.required ? ' *' : '') : undefined)

    const textFieldClassName = useMemo(() => {
        let result = "filesList";
        result += isDisabled ? '' : 'emulateEnabled';
        result += (!hideErrors && showErrorText) ? ' error' : ''
        return result
    }, [hideErrors, showErrorText, isDisabled]);

    const actionClassName = useMemo(() => {
        let result = "action";
        result += (!hideErrors && showErrorText) ? ' error' : ''
        return result;
    }, [showErrorText])

    useEffect(() => {
        // let newValue = content[field.id]
        // if (!isEqual(name, newValue.name)) {
            updateImage(content[field.id]);
        // }
    }, [content[field.id]])

    const updateImage = (value) => {
        if (isFile(value)) {
            // file
            setName(value.name)
            setImg(URL.createObjectURL(value))
            setImgAvailable(value.size > 0)
        } else if (value && typeof value === 'string') {
            // string
            setName(getStoreFileName(value))
            setImg(value)
            setImgAvailable(true)
        } else {
            setName(null)
            setImg(null)
            setImgAvailable(false)
        }
    }

    const onFileBlur = e => {
        if (onBlur) onBlur(e)
    }

    const onFileFocus = e => {
        if (onFocus) onFocus(e)
    } 

    const onFileChange = e => {
        const img = document.createElement('img');

        const selectedImage = e.target.files[0];
    
        const objectURL = URL.createObjectURL(selectedImage);

        img.onload = function handleLoad() {
            if (!field?.options?.size) {
                onChange(e);
                updateImage(e.target.value);
            }
            else if (img.width < field.options.size.width) {
                showPromt({
                    snackbarMessage: 'Ваше зображеня менше рекомендованих розмірів. Для хорошої якості зображення, ширина має бути більше ' + field.options.size.width + ' пікселів. Бажаєте продовжити?',
                    snackbarDuration: 10000,
                    onApproveHandler: () => {
                        onChange(e);
                        updateImage(e.target.value);
                        if (toaster.onCloseHandler) toaster.onCloseHandler();
                        closeToaster();
                        hideBackdropPreloader();
                    },
                })
            }
            else if (img.height < field.options.size.height) {
                showPromt({
                    snackbarMessage: 'Ваше зображеня менше рекомендованих розмірів. Для хорошої якості зображення, висота має бути більше ' + field.options.size.height + ' пікселів. Бажаєте продовжити?',
                    snackbarDuration: 10000,
                    onApproveHandler: () => {
                        onChange(e);
                        updateImage(e.target.value);
                        if (toaster.onCloseHandler) toaster.onCloseHandler();
                        closeToaster();
                        hideBackdropPreloader();
                    },
                })
            }
            else {
                onChange(e);
                updateImage(e.target.value);
            }

            URL.revokeObjectURL(objectURL);
        };

        img.src = objectURL;

        hiddenImagesRef.current.appendChild(img);
    }

    let sizeHintStyle;
    const maxSize = 58;
    if (field?.options?.size?.width && field?.options?.size?.height) {
        if (field.options.size.width < field.options.size.height) sizeHintStyle = {height: maxSize + "px", width: parseInt(field.options.size.width / (field.options.size.height / maxSize)) + "px"}
        else sizeHintStyle = {width: maxSize + "px", height: parseInt(field.options.size.height / (field.options.size.width / maxSize)) + "px"}
    }

    const imgHor = field?.options?.size?.width > field?.options?.size?.height
    const imgVert = field?.options?.size?.width < field?.options?.size?.height
    const imgQ = field?.options?.size?.width == field?.options?.size?.height

    return <div className={'UploadImage' + (isDisabled ? ' disabled' : '')}>
        <div className='fileUploadButton'>
            <div className='details'>
                <input
                    disabled={isDisabled}
                    className='originalControl'
                    accept="image/*"
                    type="file"
                    ref={inputRef}
                    onChange={onFileChange}
                    onBlur={onFileBlur}
                    onFocus={onFileFocus}
                />

                {!minimal && <TextField
                    fullWidth
                    disabled
                    className={textFieldClassName ? `TextField ${textFieldClassName}` : 'TextField'}
                    variant="outlined"
                    label={placeholder}
                    value={imgAvailable ? name : ''}
                    error={Boolean(!hideErrors && showErrorText)}
                    helperText={!hideErrors && showErrorText}
                />}

                <Button
                    className={actionClassName}
                    variant="contained"
                    component="label"
                    tabIndex={-1}
                    onClick={onButtonClick}>
                        {(!imgAvailable || hidePreview) && <AttachFileIcon />}
                </Button>
            </div>

            {!showErrorText && (sizeHintStyle || field.description) && <div className='fieldNotes'>
                {field.description && <p>* {field.description}</p>}

                {sizeHintStyle && <p>* {imgHor ? "Горизонтальна картинка" : imgVert ? "Вертикальна картинка" : imgQ ? "Квадратна картинка" : ""}, рекомендовані розміри  {field?.options?.size.width} x {field?.options?.size.height}. <span className='pseudoLink' onClick={() => setShowSizeDetails(!showSizeDetails)}>Детальніше</span></p>} {/* <InfoOutlinedIcon onClick={() => setShowSizeDetails(!showSizeDetails)}/> */}
                {sizeHintStyle && <Slide in={showSizeDetails} mountOnEnter unmountOnExit>
                    <div className='sizeHintWrap'>
                        <div className='sizeHint'>
                            <div className='sizeHintExample' style={sizeHintStyle}></div>
                        </div>
                        <div>
                            {/* {parseInt(field.options.size.width/field.options.size.height)} */}
                            {imgHor && <div className='type'>Горизонтальна картинка</div>}
                            {/* {parseInt(field.options.size.width/field.options.size.height)} */}
                            {imgVert && <div className='type'>Вертикальна картинка</div>}
                            {imgQ && <div className='type'>Квадратна картинка</div>}
                            <div>Картинка буде автоматично масштабована під вказаний розмір. Якщо пропорції будуть не відповідні, частина картинки буде обрізана</div>
                        </div>
                    </div>
                </Slide>}
            </div>}
        </div>

        {imgAvailable && !hidePreview &&
            <>
                <div className="UploadImageFormPhotos">
                <div className="photo">
                    <span className='imgWrap'>
                        <span className='close' onClick={onRemoveHandler}>
                            <ClearIcon />
                        </span>

                        {img.indexOf('http') !== 0 && <ContentImage image={img} />}
                        {img.indexOf('http') === 0 && <img loading="lazy" src={img} />}
                    </span>
                </div>
                </div>
            </>
        }
        <div className='containerForHiddenImages' ref={hiddenImagesRef}></div>
    </div>
}
